import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useState} from 'react';

import {DrawerContentType} from '../../WorkspaceDrawerContextProvider';
import {SettingsContentWrapper} from '../components/SettingsContentWrapper';
import {WORKSPACE_SEMANTIC_LEGENDS_SETTINGS_DESCRIPTION} from '../constants';
import {SemanticLegendColorTab} from './SemanticLegendColorTab';

export const SemanticLegendSettings = ({
  contentHeader,
}: {
  contentHeader?: React.ReactNode;
  displayedContentType: DrawerContentType;
}) => {
  const [selectedTab, setSelectedTab] = useState('colors');

  return (
    <SettingsContentWrapper
      title="Runs"
      description={WORKSPACE_SEMANTIC_LEGENDS_SETTINGS_DESCRIPTION}
      header={contentHeader}>
      <Tabs.Root
        className="mt-16"
        value={selectedTab}
        onValueChange={value => setSelectedTab(value)}>
        <Tabs.List>
          <Tabs.Trigger value="colors">Colors</Tabs.Trigger>
        </Tabs.List>
        <Tabs.Content value="colors">
          <SemanticLegendColorTab />
        </Tabs.Content>
      </Tabs.Root>
    </SettingsContentWrapper>
  );
};
